import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

import { t } from "@/i18n-js/instance";
import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

import { DropZone } from "../DropZone";
import { ImageError } from "./ImageError";

export interface FileUploadProps {
  aspectRatioHelpText?: string;
  imageError?: string;
  insertFiles: (files: FileList | null) => void;
}

export const FileUpload = ({
  imageError,
  insertFiles,
  aspectRatioHelpText,
}: FileUploadProps) => {
  const isSmScreen = useSmScreenMediaQuery();
  return (
    <div className={legacyClassNames("upload-form")} data-testid="upload-form">
      <ImageError error={imageError} />
      <DropZone
        onFileDrop={insertFiles}
        dropTitle={
          isSmScreen
            ? t("image_upload.click_here_to_upload_image")
            : t("image_upload.drag_image")
        }
        helperText={
          <>
            {t("image_upload.works_with_image_type")}
            {aspectRatioHelpText && (
              <>
                <br />
                {aspectRatioHelpText}
              </>
            )}
          </>
        }
      />
    </div>
  );
};
